export const ECOMMERCE_PANEL = 'ecommerce';
